(function (window) {
  'use strict';

  function venadaPrefersReducedMotion() {
    return typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function venadaScrollProgress(section, callback) {
    if (!section || typeof section.getBoundingClientRect !== 'function' || typeof callback !== 'function') return function () {};

    var scheduled = false;
    var stopped = false;
    var frameId = null;

    function update() {
      frameId = null;
      scheduled = false;
      if (stopped) return;

      var rect = section.getBoundingClientRect();
      var viewportHeight = window.innerHeight || 0;
      var distance = rect.height - viewportHeight;
      var progress = distance > 0 ? -rect.top / distance : -rect.top / Math.max(rect.height, 1);
      callback(Math.max(0, Math.min(1, progress)));
    }

    function schedule() {
      if (stopped || scheduled) return;
      scheduled = true;
      frameId = window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    schedule();

    return function () {
      stopped = true;
      if (frameId !== null) window.cancelAnimationFrame(frameId);
      frameId = null;
      scheduled = false;
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
    };
  }

  function venadaOnEnter(element, callback) {
    if (!element || typeof callback !== 'function') return function () {};

    if (typeof window.IntersectionObserver !== 'function') {
      callback(element);
      return function () {};
    }

    var entered = false;
    var stopped = false;
    var observer = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (stopped || entered || !entry.isIntersecting || entry.intersectionRatio < 0.2) return;
        entered = true;
        observer.disconnect();
        callback(entry.target);
      });
    }, { threshold: 0.2 });

    observer.observe(element);
    return function () {
      stopped = true;
      observer.disconnect();
    };
  }

  window.venadaScrollProgress = venadaScrollProgress;
  window.venadaPrefersReducedMotion = venadaPrefersReducedMotion;
  window.venadaOnEnter = venadaOnEnter;
})(window);
